import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, OnDestroy {
    hideBackButton = false;
    private routerSubscription!: Subscription;

    constructor(
        private activatedRoute: ActivatedRoute,
        private location: Location,
        private router: Router,
    ) {}

    ngOnInit(): void {
        this.routerSubscription = this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((en: NavigationEnd) => {
                //TODO: Find better solution of getting data from the route
                this.hideBackButton =
                    this.activatedRoute.firstChild?.firstChild?.firstChild?.snapshot.data['hideBackButton'];
            });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    }

    back(): void {
        this.location.back();
    }
}
